import React from 'react';
import { ROUTE_PATHS } from '../routes/Routes';
import { ContactAvailableColumns } from '../services/react-query/contacts';
import { Contact } from '../types/Contact';
import { AvailableColumn } from '../uikit/itable/ITable';
import AppLink from '../components/common/AppLink/AppLink';
import RolesPopover from '../components/common/popover/RolesPopover';
import { archiveFilter, tagFilter } from '../components/common/filters/consts';
import { IFilter } from '../components/common/filters/interfaces';
import { Preference, PREFERENCES_VALID_KEYS } from '../types/Preference';
import { mapOptionsFromPreferences } from './filterUtils';
import _ from 'lodash';
import EmailLink from '../components/common/EmailLink/EmailLink';
import PhoneLink from '../components/common/PhoneLink/PhoneLink';
import AccountLink from '../components/common/AccountLink/AccountLink';
import { UserConfigurableModule } from '../types/User';
import DrawerLink from '../components/common/drawers/ModuleDrawer/DrawerLink';

export const ContactColumns: AvailableColumn<Contact, ContactAvailableColumns>[] = [
  {
    key: 'full_name',
    label: 'Name',
    render: (contact) => (
      <DrawerLink module={UserConfigurableModule.CONTACTS} uuid={contact.uuid}>
        {[contact.first_name, contact.last_name].filter(Boolean).join(' ') || contact.full_name || 'Unnamed Contact'}
      </DrawerLink>
    ),
  },
  {
    key: 'account_name',
    label: 'Account Name',
    render: (contact) => <AccountLink uuid={contact.account_uuid} displayText={contact.account_name} />,
  },
  {
    key: 'account_code',
    label: 'Account Code',
    render: (contact) => <AccountLink uuid={contact.account_uuid} displayText={contact.account_code} />,
  },
  {
    key: 'roles',
    label: 'Roles',
    sortable: false,
    render: (contact) => <RolesPopover roles={contact.roles_values} />,
  },
  {
    key: 'contact_title_value',
    label: 'Title',
    render: (contact) => contact.contact_title_value,
  },
  {
    key: 'email',
    label: 'Email',
    render: (contact) => <EmailLink email={contact.email} />,
  },
  {
    key: 'phone_1',
    label: 'Phone 1',
    render: (contact) => <PhoneLink phone={contact.phone_1} extension={contact.extension} />,
  },
  {
    key: 'phone_2',
    label: 'Phone 2',
    render: (contact) => <PhoneLink phone={contact.phone_2} />,
  },
  {
    key: 'tags',
    label: 'Tags',
    sortable: false,
    render: (contact) => <RolesPopover roles={_.map(contact.tags, 'preference_value')} />,
  },
];

export const ContactFilters = (preferences?: Preference[]): IFilter[] => [
  {
    label: 'Contact Role',
    key: PREFERENCES_VALID_KEYS.CONTACT_ROLE,
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], PREFERENCES_VALID_KEYS.CONTACT_ROLE),
  },
  {
    label: 'Contact Title',
    key: PREFERENCES_VALID_KEYS.CONTACT_TITLE,
    type: 'dropdown',
    options: mapOptionsFromPreferences(preferences || [], PREFERENCES_VALID_KEYS.CONTACT_TITLE),
  },
  {
    label: 'Account',
    key: 'account',
    type: 'account',
  },
  {
    label: 'Account Manager',
    key: 'account_manager',
    type: 'employee',
  },
  tagFilter,
  archiveFilter,
];
